<template>
  <div>
    <button class="btn btn-edit" @click="showModal">
      <img src="@/assets/images/admin/cashpayments/edit.png" alt="Edit" style="width: 25px; height: 25px;" />
    </button>

    <!-- Modal -->
    <div v-if="show" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Driver Profile</h5>
          <button type="button" class="btn-close" @click="closeModal">X</button>
        </div>
        <div class="modal-body">
          <div class="">
            <!-- 編輯區塊切換 -->
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab === 'general' }" @click="activeTab = 'general'">General</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab === 'payment' }" @click="activeTab = 'payment'">Payment details</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab === 'documents' }" @click="activeTab = 'documents'">Documents</a>
              </li>
            </ul>

            <!-- General Tab -->
            <div v-if="activeTab === 'general'" class="tab-content">
              <div class="row d-flex align-items-start">
                <div class="col-xxl-6 col-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12">
                          <h5>Driver Information</h5>
                        </div>
                        <div class="col-12 col-md-6">
                          <label for="driver_id" class="form-label">Driver ID <span class="text-danger">*</span></label>
                          <input type="text" v-model="driver.driver_id" class="form-control" :class="{ 'is-invalid': errors.driver_id }" disabled />
                          <div v-if="errors.driver_id" class="invalid-feedback">{{ errors.driver_id }}</div>
                        </div>
                        <div class="col-12 col-md-6">
                          <label for="birthday" class="form-label"> DOB<span class="text-danger">*</span></label>
                          <Datepicker1 
                            class="datepicker-here form-control p-1" 
                            v-model="driver.birthday" 
                            :format="'dd.MM.yy'" 
                            :enable-time-picker="false" 
                            data-language="en" 
                            :class="{ 'is-invalid': errors.birthday }"
                            hide-input-icon
                          />
                          <div v-if="errors.birthday" class="invalid-feedback">{{ errors.birthday }}</div>
                        </div>
                        <div class="col-12 col-md-6">
                          <label for="first-name" class="form-label">First name <span class="text-danger">*</span></label>
                          <input type="text" v-model="driver.first_name" class="form-control" :class="{ 'is-invalid': errors.first_name }" />
                          <div v-if="errors.first_name" class="invalid-feedback">{{ errors.first_name }}</div>
                        </div>
                        <div class="col-12 col-md-6">
                          <label for="middle-name" class="form-label">Middle name</label>
                          <input type="text" v-model="driver.middle_name" class="form-control" :class="{ 'is-invalid': errors.middle_name }" />
                          <div v-if="errors.middle_name" class="invalid-feedback">{{ errors.middle_name }}</div>
                        </div>
                        <div class="col-12 col-md-6">
                          <label for="last-name" class="form-label">Last name <span class="text-danger">*</span></label>
                          <input type="text" v-model="driver.last_name" class="form-control" :class="{ 'is-invalid': errors.last_name }" />
                          <div v-if="errors.last_name" class="invalid-feedback">{{ errors.last_name }}</div>
                        </div>
                        <div class="col-12">
                          <div class="row g-3 align-items-stretch address-location-row">
                            <div class="col-12 col-md-6 d-flex flex-column h-100">
                              <label for="address" class="form-label">Address <span class="text-danger">*</span></label>
                              <textarea
                                id="address"
                                class="form-control address-textarea-stretch flex-grow-1"
                                v-model="driver.address"
                                rows="4"
                                :class="{ 'is-invalid': errors.address }"
                              ></textarea>
                              <div v-if="errors.address" class="invalid-feedback d-block">{{ errors.address }}</div>
                            </div>
                            <div class="col-12 col-md-6 d-flex flex-column">
                              <div class="row g-2 flex-grow-1">
                                <div class="col-12">
                                  <label for="suburb" class="form-label">Suburb <span class="text-danger">*</span></label>
                                  <input
                                    id="suburb"
                                    type="text"
                                    v-model="driver.suburb"
                                    class="form-control"
                                    :class="{ 'is-invalid': errors.suburb }"
                                  />
                                  <div v-if="errors.suburb" class="invalid-feedback d-block">{{ errors.suburb }}</div>
                                </div>
                                <div class="col-6">
                                  <label for="state" class="form-label">State <span class="text-danger">*</span></label>
                                  <select id="state" class="form-select digits" v-model="driver.state" :class="{ 'is-invalid': errors.state }">
                                    <option value="NSW">NSW</option>
                                    <option value="VIC">VIC</option>
                                    <option value="QLD">QLD</option>
                                    <option value="SA">SA</option>
                                    <option value="WA">WA</option>
                                    <option value="NT">NT</option>
                                    <option value="TAS">TAS</option>
                                    <option value="ACT">ACT</option>
                                  </select>
                                  <div v-if="errors.state" class="invalid-feedback d-block">{{ errors.state }}</div>
                                </div>
                                <div class="col-6">
                                  <label for="post-code" class="form-label">Post code <span class="text-danger">*</span></label>
                                  <input
                                    id="post-code"
                                    type="text"
                                    v-model="driver.post_code"
                                    class="form-control"
                                    :class="{ 'is-invalid': errors.post_code }"
                                  />
                                  <div v-if="errors.post_code" class="invalid-feedback d-block">{{ errors.post_code }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-12">
                          <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
                          <input type="email" v-model="driver.email" class="form-control" :class="{ 'is-invalid': errors.email }" />
                          <div v-if="errors.email" class="invalid-feedback">{{ errors.email }}</div>
                        </div>
                        <div class="col-md-6 col-12">
                          <label class="form-label">Email Verification</label>
                          <div class="row align-items-center g-2">
                            <div class="col-md-6 col-12">
                              <label
                                class="mb-0 email-verify-status"
                                :class="driver.is_verified ? 'text-success' : 'text-secondary'"
                              >{{ emailVerificationLabel }}</label>
                            </div>
                            <div class="col-md-6 col-12">
                              <button
                                type="button"
                                class="btn btn-primary"
                                :disabled="sendingVerificationEmail || !driver.driver_id"
                                @click="sendVerificationEmail"
                              >
                                {{ sendingVerificationEmail ? 'Sending…' : 'Send Verification email' }}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-12">
                          <label for="mobile" class="form-label">Mobile <span class="text-danger">*</span></label>
                          <input type="tel" v-model="driver.mobile" class="form-control" :class="{ 'is-invalid': errors.mobile }" />
                          <div v-if="errors.mobile" class="invalid-feedback">{{ errors.mobile }}</div>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12">
                          <h5>Password</h5>
                        </div>
                        <div class="col-md-6 col-12">
                          <label for="pin" class="form-label">Pin</label>
                          <input type="password" v-model="driver.pin" class="form-control" :class="{ 'is-invalid': errors.pin }" />
                          <div v-if="errors.pin" class="invalid-feedback">{{ errors.pin }}</div>
                        </div>
                        <div class="col-md-3 col-12 mt-4">
                          <div class="checkbox checkbox-success">
                            <input id="accessEnabled" type="checkbox" v-model="driver.accessEnabled">
                            <label for="accessEnabled">Access enabled</label>
                          </div>
                        </div>
                        <div class="col-md-3 col-12 mt-4">
                          <div class="checkbox checkbox-success">
                            <input id="badDriver" type="checkbox" v-model="driver.badDriver">
                            <label for="badDriver">Bad driver</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Licensing & Operations -->
                <div class="col-xxl-3 col-12 justify-content-start">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12">
                          <h5>Licensing & Operations</h5>
                        </div>
                        <div class="col-12">
                          <label for="license-number" class="form-label">License number <span class="text-danger">*</span></label>
                          <input type="text" v-model="driver.license_number" class="form-control" :class="{ 'is-invalid': errors.license_number }" />
                          <div v-if="errors.license_number" class="invalid-feedback">{{ errors.license_number }}</div>
                        </div>
                        <div class="col-12">
                          <label for="plate-number" class="form-label">Plate number <span class="text-danger">*</span></label>
                          <input type="text" v-model="driver.plate_number" class="form-control" :class="{ 'is-invalid': errors.plate_number }" />
                          <div v-if="errors.plate_number" class="invalid-feedback">{{ errors.plate_number }}</div>
                        </div>
                        <div class="col-12">
                          <label for="abn" class="form-label">ABN <span class="text-danger">*</span></label>
                          <input type="text" v-model="driver.abn" class="form-control" :class="{ 'is-invalid': errors.abn }" />
                          <div v-if="errors.abn" class="invalid-feedback">{{ errors.abn }}</div>
                        </div>
                        <div class="col-12">
                          <label for="confirmed-abn" class="form-label">Confirmed ABN <span class="text-danger">*</span></label>
                          <input type="text" v-model="driver.confirmed_abn" class="form-control" :class="{ 'is-invalid': errors.confirmed_abn }" />
                          <div v-if="errors.confirmed_abn" class="invalid-feedback">{{ errors.confirmed_abn }}</div>
                        </div>
                        <div class="col-12">
                          <label for="commission-subgroup" class="form-label">Commission subgroup <span class="text-danger">*</span></label>
                          <select class="form-select digits" v-model="driver.subgroup" :class="{ 'is-invalid': errors.subgroup }">
                            <option value="" disabled selected>Select...</option>
                            <option v-for="(item, index) in paginatedData" :value="item.id">{{ item.name }}</option>
                          </select>
                          <div v-if="errors.subgroup" class="invalid-feedback">{{ errors.subgroup }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12">
                          <h5>History</h5>
                        </div>
                        <div class="col-12">
                          <label for="license-number" class="form-label">Created</label>
                          <input type="text" v-model="driver.created_at" class="form-control" disabled />
                        </div>
                        <div class="col-12">
                          <label for="plate-number" class="form-label">Updated</label>
                          <input type="text" v-model="driver.updated_at" class="form-control" disabled />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Notes -->
                <div class="col-xxl-3 col-12">
                  <div class="card notes">
                    <div class="card-body">
                      <h5>Notes</h5>
                      <div class="notes-list">
                        <div v-for="note in sortedNotes" :key="note.id" class="note-item">
                          <div class="row note-header">
                            <div class="col">
                              <p>{{ note.date }}</p>
                            </div>
                            <div class="col text-end">
                              <p>{{ note.author  }}</p>
                            </div>
                          </div>
                          <div class="note-body">
                            <p>{{ note.text }}</p>
                            <div class="note-body-button text-center">
                              <button @click="togglePin(note.id)" class="note-btn p-0 btn btn-link btn" :class="{'pinned': note.pinned}">
                                <img v-if="note.pinned != false" src="@/assets/images/admin/cashpayments/mark-active.png" alt="" style="width: 20px; height: 20px;" />
                                <img v-else src="@/assets/images/admin/cashpayments/mark-inactive.png" alt="delete" style="width: 20px; height: 20px;" />
                              </button>
                              <button @click="removeNote(note.id)" class="note-btn btn btn-link btn">
                                <img src="@/assets/images/admin/cashpayments/trush.png" alt="delete" style="width: 20px; height: 20px;" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="add-note-section">
                        <button class="note-add_btn btn btn-primary btn-sm p-0" @click="showAddNoteInput = true">
                          <img class="note-add_btn" src="@/assets/images/admin/cashpayments/addnote.png" alt="Add Note" style="width: 30px; height: 30px;" />
                        </button>
                        <div v-if="showAddNoteInput" class="add-note-input">
                          <p class="m-1">Add Note</p>
                          <textarea v-model="newNoteText" rows="3" class="form-control"></textarea>
                          <div class="text-end mt-2">
                            <button class="btn p-0 text_gary" @click="cancelAddNote">Cancel</button>
                            <button class="btn ms-3 p-0 text_purple" @click="addNote">Add</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Payment Details Tab -->
            <div v-if="activeTab === 'payment'" class="tab-content">
              <div class="row d-flex align-items-stretch">
                <div class="col-xxl-4">
                  <div class="card mb-0">
                    <div class="card-body">
                      <h5>Method <span class="text-danger">*</span></h5>
                      <select class="form-select digits" v-model="driver.paymentMethod" @change="handlePaymentMethodChange" :class="{ 'is-invalid': errors.paymentMethod }">
                        <option value="Bank transfer">Bank transfer</option>
                        <option value="Cash">Cash</option>
                      </select>
                      <div v-if="errors.paymentMethod" class="invalid-feedback">{{ errors.paymentMethod }}</div>
                    </div>
                  </div>
                  <div class="card mt-3">
                    <div class="card-body">
                      <div class="media">
                        <label class="col-form-label m-r-10 f-20">Payment enabled?</label>
                        <div class="media-body text-end icon-state switch-outline">
                          <label class="switch">
                            <input type="checkbox" v-model="driver.paymentEnabled"><span class="switch-state bg-success"></span>
                          </label>
                        </div>
                      </div>
                      <div class="media">
                        <label class="col-form-label m-r-10 f-20">Withdraw funds enabled?</label>
                        <div class="media-body text-end icon-state switch-outline">
                          <label class="switch">
                            <input type="checkbox" v-model="driver.withdraw_enabled"><span class="switch-state bg-success"></span>
                          </label>
                        </div>
                      </div>
                      <div class="media">
                        <label class="col-form-label m-r-10 f-20">Driver pre-card enabled?</label>
                        <div class="media-body text-end icon-state switch-outline">
                          <label class="switch">
                            <input type="checkbox" v-model="driver.pre_card_enabled"><span class="switch-state bg-success"></span>
                          </label>
                        </div>
                      </div>
                      <div class="media" v-if="cardAccount">
                        <label class="col-form-label m-r-10 f-20">Card auto-pay enabled?</label>
                        <div class="media-body text-end icon-state switch-outline">
                          <label class="switch">
                            <input type="checkbox" v-model="cardAccount.auto_pay"><span class="switch-state bg-success"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card mb-0">
                    <div class="card-body">
                      <h5>Referral information (if applicable)</h5>
                      <div class="row">
                        <div class="col-12">
                          <label for="referring-driver-id" class="form-label">Referring driver ID</label>
                          <input type="text" v-model="driver.referringDriverId" class="form-control" />
                        </div>
                        <div class="col-12">
                          <label for="referring-driver-name" class="form-label">Referring driver name</label>
                          <input type="text" v-model="driver.referringDriverName" class="form-control" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xxl-8">
                  <div class="card mb-0">
                    <div class="card-body">
                      <h5 v-if="driver.paymentMethod === 'Bank transfer'">Bank details</h5>
                      <h5 v-else>Bank / PayID details</h5>

                      <div v-if="driver.paymentMethod === 'Cash'">
                        <button class="btn btn-sm d-flex justify-content-between align-items-center" @click="addAccount">
                          <img class="note-add_btn" src="@/assets/images/admin/cashpayments/addnote.png" alt="Add Note" style="width: 30px; height: 30px;" />
                          <div class="ms-3">Add details</div>
                        </button>
                      </div>
                      <hr>
                      <div
                        v-for="(account, idx) in driver.accounts"
                        :key="account.tempId"
                      >
                        <div class="row d-flex align-items-center">
                          <div v-if="driver.paymentMethod === 'Cash'" class="col-1">
                            <div>
                              <button class="btn" @click="removeAccount(idx)">
                                <img src="@/assets/images/admin/cashpayments/trush.png" alt="delete" style="width: 20px; height: 20px;" />
                              </button>
                            </div>
                          </div>
                          <div class="row" :class="driver.paymentMethod == 'Cash' ? 'col-11': 'col-12'">
                            <div class="col-md-6 col-12 mt-2">
                              <label class="form-label">
                                Nick name <span class="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                v-model="account.nick_name"
                                class="form-control"
                                :class="{ 'is-invalid': account.errors?.nick_name }"
                              />
                              <div v-if="account.errors?.nick_name" class="invalid-feedback">
                                {{ account.errors.nick_name }}
                              </div>
                            </div>

                            <div class="col-md-6 col-12 mt-2" v-if="driver.paymentMethod === 'Cash'">
                              <label class="form-label">Account type</label>
                              <select
                                class="form-select digits"
                                v-model="account.type"
                                :class="{ 'is-invalid': account.errors?.type }"
                                @change="resetAccountFields(account)"
                              >
                                <option value="1">Bank account</option>
                                <option value="2">PayID phone</option>
                                <option value="3">PayID email</option>
                                <option value="4">Card</option>
                              </select>
                              <div v-if="account.errors?.type" class="invalid-feedback">
                                {{ account.errors.type }}
                              </div>
                            </div>

                            <div class="col-12 mt-2" :class="driver.paymentMethod === 'Cash' && account.type === '1' ? 'col-md-3' : 'col-md-6'">
                              <label class="form-label">
                                Account name <span class="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                v-model="account.account_name"
                                class="form-control"
                                :class="{ 'is-invalid': account.errors?.account_name }"
                                :disabled="driver.paymentMethod === 'Cash' && (account.type === '2' || account.type === '3')"
                              />
                              <div v-if="account.errors?.account_name" class="invalid-feedback">
                                {{ account.errors.account_name }}
                              </div>
                            </div>

                            <template v-if="account.type == '1'">
                              <div class="col mt-2">
                                <label class="form-label">
                                  Bank <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  v-model="account.bank"
                                  class="form-control"
                                  :class="{ 'is-invalid': account.errors?.bank }"
                                />
                                <div v-if="account.errors?.bank" class="invalid-feedback">
                                  {{ account.errors.bank }}
                                </div>
                              </div>
                              <div class="col mt-2">
                                <label class="form-label">
                                  BSB <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  v-model="account.bsb"
                                  @input="normalizeBsb(account)"
                                  class="form-control"
                                  :class="{ 'is-invalid': account.errors?.bsb }"
                                />
                                <div v-if="account.errors?.bsb" class="invalid-feedback">
                                  {{ account.errors.bsb }}
                                </div>
                              </div>
                              <div class="col mt-2">
                                <label class="form-label">
                                  Account number <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  v-model="account.account_number"
                                  @input="normalizeAccountNumber(account)"
                                  class="form-control"
                                  :class="{ 'is-invalid': account.errors?.account_number }"
                                />
                                <div v-if="account.errors?.account_number" class="invalid-feedback">
                                  {{ account.errors.account_number }}
                                </div>
                              </div>
                            </template>

                            <template v-else-if="account.type == '2'">
                              <div class="col-md-6 col-12 mt-2">
                                <label class="form-label">
                                  PayID Phone <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  v-model="account.phone"
                                  @keyup.enter="handlePayIdEnter(account, 'PHONE')"
                                  @input="clearAccountName(account)"
                                  class="form-control"
                                  :class="{ 'is-invalid': account.errors?.phone }"
                                />
                                <div v-if="account.errors?.phone" class="invalid-feedback">
                                  {{ account.errors.phone }}
                                </div>
                              </div>
                            </template>

                            <template v-else-if="account.type == '3'">
                              <div class="col-md-6 col-12 mt-2">
                                <label class="form-label">
                                  PayID Email <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  v-model="account.email"
                                  @keyup.enter="handlePayIdEnter(account, 'EMAIL')"
                                  @input="onAccountEmailInput(account)"
                                  class="form-control"
                                  :class="{ 'is-invalid': account.errors?.email }"
                                />
                                <div v-if="account.errors?.email" class="invalid-feedback">
                                  {{ account.errors.email }}
                                </div>
                              </div>
                            </template>

                            <template v-else-if="account.type == '4'">
                              <div class="col-md-6 col-12 mt-2">
                                <label class="form-label">
                                  Card ID(EAID) <span class="text-danger">*</span>
                                </label>
                                <input type="text" v-model="account.card_id" class="form-control" :class="{ 'is-invalid': account.errors?.card_id }" />
                                <div v-if="account.errors?.card_id" class="invalid-feedback">{{ account.errors.card_id }}</div>
                              </div>
                            </template>
                          </div>          
                        </div>      
                        <hr>
                      </div>                      
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Documents Tab -->
            <div v-if="activeTab === 'documents'" class="tab-content">
              <div class="row d-flex align-items-start">
                <!-- Documents section -->
                <div class="col-xxl-8">
                  <div class="card card-mh">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12">
                          <h5>Driving License</h5>
                        </div>
                        <div class="col-md-6 col-12 mt-3">
                          <!-- Upload License Front -->
                          <div class="file-upload">
                            <div class="license-preview" v-if="driver.licenseFrontFile.length">
                              <img :src="getObjectURL(driver.licenseFrontFile[0].content)" alt="License Front Preview" class="img-fluid" />
                            </div>
                            <div class="license-placeholder" v-else>
                              No license on file
                            </div>
                            <input type="file" @change="uploadLicenseFront" accept="image/*" class="d-none" ref="licenseFrontInput" />
                            <button class="mt-3 btn-w-transparent btn btn-outline-primary mt-2" @click="triggerFileInput('licenseFrontInput')">Upload new license front</button>
                            <div v-if="errors.licenseFrontFile" class="invalid-feedback">{{ errors.licenseFrontFile }}</div>
                          </div>
                        </div>
                        <div class="col-md-6 col-12 mt-3">
                          <!-- Upload License Back -->
                          <div class="file-upload">
                            <div class="license-preview" v-if="driver.licenseBackFile.length">
                              <img :src="getObjectURL(driver.licenseBackFile[0].content)" alt="License Back Preview" class="img-fluid" />
                            </div>
                            <div class="license-placeholder" v-else>
                              No license on file
                            </div>
                            <input type="file" @change="uploadLicenseBack" accept="image/*" class="d-none" ref="licenseBackInput" />
                            <button class="mt-3 btn-w-transparent btn btn-outline-primary mt-2" @click="triggerFileInput('licenseBackInput')">Upload new license back</button>
                            <div v-if="errors.licenseBackFile" class="invalid-feedback">{{ errors.licenseBackFile }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Other Documents Section -->
                <div class="col-xl-4 col-12">
                  <div class="card card-other card-mh">
                    <div class="card-body" style="padding: 1rem">
                      <h5>Other Documents</h5>
                      <div class="document-list p-3">
                        <div v-for="(doc, index) in driver.otherDocuments" :key="index" class="document-item pb-3 mb-3">
                          <span class="document-name">{{ doc.name }}</span>
                          <div>
                            <button class="document-button py-0 btn btn-link btn-view" @click="openPreviewModal(index)">
                              <img class="note-add_btn" src="@/assets/images/admin/cashpayments/view.png" alt="view" style="width: 25px; height: 25px;" />
                            </button>
                            <button class="document-button py-0 btn btn-link" @click="removeDocument(index)">                            
                              <img class="note-add_btn" src="@/assets/images/admin/cashpayments/trush.png" alt="delete" style="width: 25px; height: 25px;" />
                            </button>
                          </div>
                        </div>
                        <div class="add-document justify-content-start">
                          <button class="document-add_btn p-0 btn btn-primary btn-sm" @click="triggerFileInput('fileInput')">
                            <img class="note-add_btn" src="@/assets/images/admin/cashpayments/addnote.png" alt="Add Doc" style="width: 30px; height: 30px;" />
                          </button>
                          <input type="file" ref="fileInput" @change="handleFileUpload" class="d-none" />
                          <div v-if="errors.otherDocuments" class="invalid-feedback">{{ errors.otherDocuments }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="modal-footer">
          <div class="row justify-content-start">
            <div class="col">
              <button class="btn btn-green" @click="submitDriver">Save</button>
            </div>
            <div class="col">
              <button class="btn btn-cancel btn-w" @click="closeModal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 預覽圖片 -->
    <div v-if="showPreview" class="preview-modal-overlay" @click.self="closePreviewModal">
      <div class="preview-modal-content">
        <button type="button" class="btn-close justify-content-end" @click="closePreviewModal">X</button>
        <div class="preview-content">
          <img :src="getObjectURL(previewDocument.content)" alt="Document Preview" class="img-fluid" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, defineProps } from 'vue';
import { useDriverStore } from '@/store/admin/driver';
import { useSubgroupStore } from '@/store/admin/subgroup';
import Swal from 'sweetalert2'; // 導入Sweetalert2來顯示錯誤訊息
import Datepicker1 from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

const props = defineProps({
  driverId: Number,
});

const show = ref(false);
const activeTab = ref('general');
const showAddNoteInput = ref(false);
const newNoteText = ref('');
const showPreview = ref(false);
const previewDocument = ref({});
const driverStore = useDriverStore();
const subgroupStore = useSubgroupStore();
const deletedNoteIds = ref([]);
const deletedDocumentIds = ref([]); // 用於存儲要刪除的文件ID
const sendingVerificationEmail = ref(false);

// 驗證錯誤訊息
const errors = reactive({
  driver_id: '',
  birthday: '',
  first_name: '',
  middle_name:'',
  last_name: '',
  address: '',
  suburb: '',
  state: '',
  post_code: '',
  mobile: '',
  email: '',
  pin: '',
  license_number: '',
  plate_number: '',
  abn: '',
  confirmed_abn: '',
  subgroup: '',
  paymentMethod: '',
  bsb: '',
  accountNumber: '',
  bank: '',
  accountName: '',
  nickName: '',
  card_id:'',
  phone:'',
  account_email:'',
  licenseFrontFile: '',
  licenseBackFile: '',
  otherDocuments: '',
});

const paginatedData = computed(() => {
  return subgroupStore.paginatedData;
});

// Driver data
const driver = reactive({
  driver_id: '',
  birthday: null,
  first_name: '',
  middle_name:'',
  last_name: '',
  address: '',
  suburb: '',
  state: '',
  post_code: '',
  mobile: '',
  email: '',
  pin: '',
  accessEnabled: false,
  badDriver: false,
  license_number: '',
  plate_number: '',
  abn: '',
  confirmed_abn: '',
  subgroup: '',
  created_at:'',
  updated_at:'',
  licenseFrontFile: [],
  licenseBackFile: [],
  otherDocuments: [],
  notes: [],
  paymentMethod: 'Bank transfer',
  paymentEnabled: false,
  withdraw_enabled: false,
  pre_card_enabled: false,
  referringDriverId: '',
  referringDriverName: '',
  accounts: '',
  is_verified: false,
});

// 設置Driver資料
const setDriverData = (data) => {
  driver.driver_id = data.driver_id;
  // 將字串格式的日期 (YYYY-MM-DD) 轉換為 Date 物件
  if (data.birthday && typeof data.birthday === 'string') {
    // 解析 YYYY-MM-DD 格式的日期字串
    const dateParts = data.birthday.split('-');
    if (dateParts.length === 3) {
      // 使用本地時間創建日期，避免時區問題
      driver.birthday = new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]));
    } else {
      driver.birthday = new Date(data.birthday);
    }
  } else if (data.birthday instanceof Date) {
    driver.birthday = data.birthday;
  } else {
    driver.birthday = null;
  }
  driver.first_name = data.first_name;
  driver.middle_name = data.middle_name ?? '';
  driver.last_name = data.last_name;
  driver.address = data.address;
  driver.suburb = data.suburb;
  driver.state = data.state;
  driver.post_code = data.post_code;
  driver.mobile = data.mobile;
  driver.email = data.email;
  driver.is_verified = data.is_verified === true ;
  driver.pin = ''; // Resetting pin field
  driver.accessEnabled = data.enabled === 1;
  driver.badDriver = data.bad_driver === 1;
  driver.license_number = data.license?.license_number || '';
  driver.plate_number = data.license?.plate_number || '';
  driver.abn = data.license?.abn || '';
  driver.confirmed_abn = data.license?.confirmed_abn || '';
  driver.subgroup = data.subgroup?.id || '';
  driver.created_at = data.created_at || '';
  driver.updated_at = data.updated_at || '';
  driver.notes = data.notes.map(note => ({
    id: note.id,
    text: note.note,
    date: note.created_at,
    author: `${note.member.first_name} ${note.member.last_name}`,
    pinned: note.eye_catching === 1,
  })) || [];
  driver.paymentMethod = data.payment_detail?.method || 'Bank transfer';
  driver.paymentEnabled = data.payment_detail?.enabled === 1;
  driver.withdraw_enabled = data.payment_detail?.withdraw_enabled === 1;
  driver.pre_card_enabled = data.payment_detail?.pre_card_enabled === 1;
  driver.accounts = (data.payment_detail?.account_details || []).map(acc => ({
    tempId: generateId(), 
    id: acc.id,           
    type: String(acc.type || '1'), // 後端若是數字，前端轉字串，方便 v-model
    nick_name: acc.nick_name || '',
    account_name: acc.account_name || '',
    bank: acc.bank || '',
    bsb: acc.bsb || '',
    account_number: acc.account_number || '',
    phone: acc.phone || '',
    email: acc.email || '',
    card_id: acc.EAID || '',
    enabled: acc.enabled === 1,
    auto_pay: acc.auto_pay !== 2,
    errors: {},
  }));
  driver.referringDriverId = data.payment_detail?.referring_driver_id || '';
  driver.referringDriverName = data.payment_detail?.referring_driver_name || '';

  // 設置文件
  driver.licenseFrontFile = data.documents.filter(doc => doc.document_name === 'license_front').map(doc => ({
    id: doc.id,
    content: doc.document_url,
  }));
  driver.licenseBackFile = data.documents.filter(doc => doc.document_name === 'license_back').map(doc => ({
    id: doc.id,
    content: doc.document_url,
  }));
  driver.otherDocuments = data.documents.filter(doc => doc.document_name !== 'license_front' && doc.document_name !== 'license_back').map(doc => ({
    id: doc.id,
    name: doc.document_name,
    content: doc.document_url,
  }));

  if (driver.paymentMethod === 'Bank transfer' && driver.accounts.length === 0) {
    driver.accounts.push({
      tempId: generateId(),
      id: null,
      nick_name: '',
      account_name: '',
      bank: '',
      bsb: '',
      account_number: '',
      phone: '',
      email:'',
      enabled: false,
      errors: {},
    });
  }

  if (driver.paymentMethod === 'Cash' && driver.accounts.length === 0) {
    driver.accounts.push({
      tempId: generateId(),
      id: null,
      type: '1', 
      nick_name: '',
      account_name: '',
      bank: '',
      bsb: '',
      account_number: '',
      phone: '',
      email:'',
      card_id:'',
      enabled: false,
      errors: {},
    });
  }
};

// File input references
const licenseFrontInput = ref(null);
const licenseBackInput = ref(null);
const fileInput = ref(null);

const showModal = async () => {
  if (props.driverId) {
    await fetchDriverData(props.driverId);
  }
  show.value = true;
};

const closeModal = () => {
  show.value = false;
  // 清除 errors
  for (const key in errors) {
    errors[key] = '';
  }
  // 同時清空每個 account 的錯誤
  driver.accounts.forEach(acc => acc.errors = {});
};

const fetchDriverData = async (driverId) => {
  try {
    const driverData = await driverStore.fetchDriverById(driverId);
    setDriverData(driverStore.driver);
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'Error fetching driver data',
      text: error.message,
    });
  }
};

const format = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  const hh = String(date.getHours()).padStart(2, '0'); // 小時補齊2位數
  const min = String(date.getMinutes()).padStart(2, '0'); // 分鐘補齊2位數

   return `${day}/${month}/${year} ${hh}:${min}`; // 返回完整日期與時間
};

// 找到 Card 類型的 account (type === '4')
const cardAccount = computed(() => {
  if (!driver.accounts || !Array.isArray(driver.accounts)) return null;
  return driver.accounts.find(acc => acc.type === '4') || null;
});

const sortedNotes = computed(() => {
  return [...driver.notes].sort((a, b) => b.pinned - a.pinned);
});

const emailVerificationLabel = computed(() =>
  driver.is_verified ? 'Verified' : 'Unverified'
);


const addNote = () => {
  const adminData = JSON.parse(localStorage.getItem('Admin') || '{}'); // 從 localStorage 取得 Admin 資訊
  const currentAuthor = adminData.username || 'Unknown'; // 使用 username，如果找不到則設為 'Unknown'

  if (newNoteText.value.trim()) {
    driver.notes.push({
      id: generateId(),
      text: newNoteText.value,
      date: format(new Date()),
      author: currentAuthor, 
      pinned: false,
    });
    newNoteText.value = '';
    showAddNoteInput.value = false;
  }
};


const cancelAddNote = () => {
  newNoteText.value = '';
  showAddNoteInput.value = false;
};


const sendVerificationEmail = async () => {
  const driverId = String(driver.driver_id || '').trim();
  if (!driverId) {
    Swal.fire({
      icon: 'error',
      title: 'Unable to send email',
      text: 'Driver ID is missing.',
    });
    return;
  }

  sendingVerificationEmail.value = true;
  try {
    const data = await driverStore.sendVerificationEmail(driverId);
    if (data) {
      Swal.fire({
        icon: 'success',
        title: data.message || 'Verification email sent successfully.',
        showConfirmButton: false,
        timer: 1500,
      });
    }
  } catch (error) {
    console.error('Error sending verification email:', error);
    const msg =
      error.response?.data?.message ||
      error.message ||
      'Failed to send verification email. Please try again.';
    Swal.fire({
      icon: 'error',
      title: msg,
    });
  } finally {
    sendingVerificationEmail.value = false;
  }
};


const removeNote = (id) => {
  Swal.fire({
    title: 'Are you sure?',
    text: "Do you really want to delete this note?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  }).then((result) => {
    if (result.isConfirmed) {
      const noteIndex = driver.notes.findIndex(note => note.id === id);
      if (noteIndex !== -1) {
        deletedNoteIds.value.push(id);
        driver.notes.splice(noteIndex, 1);
      }
    }
  });
};

const togglePin = (id) => {
  const note = driver.notes.find(note => note.id === id);
  if (note) {
    note.pinned = !note.pinned;
  }
};

const validateFields = () => {
  let valid = true;

  // 驗證必填欄位
  if (!driver.driver_id) {
    errors.driver_id = 'Driver ID is required.';
    valid = false;
  } else {
    errors.driver_id = '';
  }

  errors.middle_name = '';

  if (!driver.first_name) {
    errors.first_name = 'First name is required.';
    valid = false;
  } else {
    errors.first_name = '';
  }

  if (!driver.last_name) {
    errors.last_name = 'Last name is required.';
    valid = false;
  } else {
    errors.last_name = '';
  }

  if (!driver.address) {
    errors.address = 'Address is required.';
    valid = false;
  } else {
    errors.address = '';
  }

  if (!driver.suburb) {
    errors.suburb = 'Suburb is required.';
    valid = false;
  } else {
    errors.suburb = '';
  }

  if (!driver.state) {
    errors.state = 'State is required.';
    valid = false;
  } else {
    errors.state = '';
  }

  if (!driver.post_code) {
    errors.post_code = 'Post code is required.';
    valid = false;
  } else {
    errors.post_code = '';
  }

  if (!driver.mobile) {
    errors.mobile = 'Mobile number is required.';
    valid = false;
  } else if (!/^\d{10}$/.test(driver.mobile)) {
    errors.mobile = 'Mobile number must be 10 digits.';
    valid = false;
  } else {
    errors.mobile = '';
  }

  if (!driver.email) {
    errors.email = 'Email is required.';
    valid = false;
  } else if (!/\S+@\S+\.\S+/.test(driver.email)) {
    errors.email = 'Invalid email address.';
    valid = false;
  } else {
    errors.email = '';
  }

  if (driver.pin && !/^\d{6}$/.test(driver.pin)) {
    errors.pin = 'Pin must be exactly 6 digits long and contain only numbers.';
    valid = false;
  } else {
    errors.pin = '';
  }

  if (!driver.license_number) {
    errors.license_number = 'License number is required.';
    valid = false;
  } else {
    errors.license_number = '';
  }

  if (!driver.plate_number) {
    errors.plate_number = 'Plate number is required.';
    valid = false;
  } else {
    errors.plate_number = '';
  }

  if (!driver.abn) {
    errors.abn = 'ABN is required.';
    valid = false;
  } else {
    errors.abn = '';
  }

  if(!driver.confirmed_abn){
    errors.confirmed_abn = 'Confirmed ABN is required.';
    valid = false;
  } else {
    errors.confirmed_abn = '';
  }

  if (!driver.subgroup) {
    errors.subgroup = 'Commission subgroup is required.';
    valid = false;
  } else {
    errors.subgroup = '';
  }

  if (!driver.paymentMethod) {
    errors.paymentMethod = 'Payment method is required.';
    valid = false;
  } else {
    errors.paymentMethod = '';
  }

  driver.accounts.forEach((acc) => {
    acc.errors = {}; // 先清空該筆的錯誤
    if (!acc.nick_name) {
      acc.errors.nick_name = 'Nick name is required.';
      valid = false;
    }
    if (!acc.account_name) {
      acc.errors.account_name = 'Account name is required.';
      valid = false;
    }
    if (acc.type === '1') {
      // Bank account => bank, bsb, account_number 必填
      if (!acc.bank) {
        acc.errors.bank = 'Bank name is required.';
        valid = false;
      }
      if (!acc.bsb) {
        acc.errors.bsb = 'BSB is required.';
        valid = false;
      } else if (!/^\d{6}$/.test(acc.bsb)) {
        acc.errors.bsb = 'BSB must be exactly 6 digits.';
        valid = false;
      }
      if (!acc.account_number) {
        acc.errors.account_number = 'Account number is required.';
        valid = false;
      } else if (!/^\d{4,}$/.test(acc.account_number)) {
        acc.errors.account_number = 'Account number must be at least 4 digits.';
        valid = false;
      }
    } else if (acc.type === '2') {
      // PayID => phone 必填
      if (!acc.phone) {
        acc.errors.phone = 'Phone is required for PayID.';
        valid = false;
      }
    } else if (acc.type === '3') {
      // PayID => email 必填
      if (!acc.email) {
        acc.errors.email = 'Email is required for PayID.';
        valid = false;
      }
    }
  });

  if (!valid) {
    Swal.fire({
      icon: 'error',
      title: 'Validation Error',
      text: 'Please check the required fields and correct them.',
    });
  }

  return valid;
};

// 當選擇為 Cash 時清除銀行資料錯誤
const handlePaymentMethodChange = () => {
  if (driver.paymentMethod === 'Bank transfer') {
    // 若原先 accounts 有多筆 => 保留第一筆即可
    if (driver.accounts.length > 0) {
      driver.accounts = [driver.accounts[0]];
      driver.accounts[0].type = '1'; // 強制 Bank
    } else {
      // 若完全沒有帳號 => 新增一筆 Bank
      addAccount(true);
    }
  }
};

const clearAccountName = (account) => {
  if (account.account_name) {
    account.account_name = '';
  }
};

/** 新增帳號: isBank 用於判斷是否強制 type=1 */
const addAccount = (isBank = false) => {
  // 如果 paymentMethod=Bank => 只允許一筆 => 不可再新增
  if (driver.paymentMethod === 'Bank transfer') return;

  driver.accounts.push({
    tempId: generateId(),
    id: null,
    type: isBank ? '1' : '1', // 預設給 '1'(Bank) 或自行切換 (若預設 PayID，可改成 '2' 或 '3')
    nick_name: '',
    account_name: '',
    bank: '',
    bsb: '',
    account_number: '',
    phone: '',
    email: '',
    enabled: false,
    errors: {},
    auto_pay: false,
  });
};

/** 移除帳號 (只在 Cash 時可用) */
const removeAccount = (index) => {
  Swal.fire({
    title: 'Are you sure?',
    text: "Do you really want to remove this account?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, remove it!',
  }).then((result) => {
    if (result.isConfirmed) {
      const acc = driver.accounts[index];
      // 如果後端已經有 id => 可另外傳刪除ID
      if (acc.id) {
        deletedDocumentIds.value.push(acc.id);
      }
      driver.accounts.splice(index, 1);
    }
  });
};

const uploadLicenseFront = (event) => {
  const files = event.target.files;
  if (files.length > 0) {
    if (files[0].size > 25 * 1024 * 1024) {
      Swal.fire({
        icon: 'error',
        title: 'File too large',
        text: 'License front file must be smaller than 25MB.',
      });
      driver.licenseFrontFile = [];
    } else {
      if (driver.licenseFrontFile.length > 0 && driver.licenseFrontFile[0].id) {
        deletedDocumentIds.value.push(driver.licenseFrontFile[0].id);
      }
      driver.licenseFrontFile = [{ content: files[0] }];
      errors.licenseFrontFile = '';
    }
  }
};

const uploadLicenseBack = (event) => {
  const files = event.target.files;
  if (files.length > 0) {
    if (files[0].size > 25 * 1024 * 1024) {
      Swal.fire({
        icon: 'error',
        title: 'File too large',
        text: 'License back file must be smaller than 25MB.',
      });
      driver.licenseBackFile = [];
    } else {
      if (driver.licenseBackFile.length > 0 && driver.licenseBackFile[0].id) {
        deletedDocumentIds.value.push(driver.licenseBackFile[0].id);
      }
      driver.licenseBackFile = [{ content: files[0] }];
      errors.licenseBackFile = '';
    }
  }
};

const handleFileUpload = (event) => {
  const files = event.target.files;
  if (files.length > 0) {
    const file = files[0];
    if (file.size > 25 * 1024 * 1024) {
      Swal.fire({
        icon: 'error',
        title: 'File too large',
        text: 'Other document file must be smaller than 25MB.',
      });
      return;
    }
    driver.otherDocuments.push({
      id: generateId(),
      name: file.name,
      content: file,
      showPreview: false
    });
    errors.otherDocuments = '';
  }
};

const triggerFileInput = (refName) => {
  if (refName === 'licenseFrontInput') {
    licenseFrontInput.value?.click();
  } else if (refName === 'licenseBackInput') {
    licenseBackInput.value?.click();
  } else if (refName === 'fileInput') {
    fileInput.value?.click();
  }
};

const openPreviewModal = (index) => {
  previewDocument.value = driver.otherDocuments[index];
  showPreview.value = true;
};

const closePreviewModal = () => {
  showPreview.value = false;
  previewDocument.value = {};
};

const getObjectURL = (file) => {
  if (typeof file === 'string') {
    return encodeURI(file);
  } else if (file instanceof Blob || file instanceof File) {
    return URL.createObjectURL(file);
  } else {
    return '';
  }
};

const removeDocument = (index) => {
  Swal.fire({
    title: 'Are you sure?',
    text: "Do you really want to delete this document?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  }).then((result) => {
    if (result.isConfirmed) {
      const doc = driver.otherDocuments[index];
      if (doc.content && typeof doc.content !== 'string') {
        URL.revokeObjectURL(doc.content);
      }
      if (doc.id) {
        deletedDocumentIds.value.push(doc.id);
      }
      driver.otherDocuments.splice(index, 1);
      errors.otherDocuments = '';
    }
  });
};

const generateId = () => '_' + Math.random().toString(36).substr(2, 9);

// 新增：處理按下 Enter 鍵後自動帶入 Account Name
const handlePayIdEnter = async (account, type) => {
  let pay_id = type === 'PHONE' ? account.phone : account.email;
  if (!pay_id) return;
  try {
    const accountName = await driverStore.GetPayIdAccountName(pay_id, type);
    if (accountName) {
      account.account_name = accountName;
      account.errors.account_name = '';
    }else{
      account.account_name = '';
      account.errors.account_name = 'Account name not found. Please try again.'
    }
  } catch (error) {
    console.error(error);
  }
};

// 新增：每次切換帳號類型時重置該筆的內容
const resetAccountFields = (account) => {
  account.nick_name = '';
  account.account_name = '';
  account.bank = '';
  account.bsb = '';
  account.account_number = '';
  account.phone = '';
  account.email = '';
  account.errors = {};
};

// 正規化銀行帳戶欄位：只允許數字，並套用長度限制
const normalizeBsb = (account) => {
  if (!account.bsb && account.bsb !== 0) return;
  account.bsb = String(account.bsb).replace(/\D/g, '').slice(0, 6); // 最多 6 位數字
};

const normalizeAccountNumber = (account) => {
  if (!account.account_number && account.account_number !== 0) return;
  account.account_number = String(account.account_number).replace(/\D/g, ''); // 只保留數字，不限制上限長度
};
const normalizeAccountEmail = (account) => {
  if (account.email === null || account.email === undefined) return;
  account.email = String(account.email)
    .replace(/\u3000/g, ' ')
    .trim()
    .replace(/\s+/g, '')
    .toLowerCase();
};

const onAccountEmailInput = (account) => {
  normalizeAccountEmail(account);
  clearAccountName(account);
};

const submitDriver = async () => {
  if (!validateFields()) {
    return;
  }

  const formData = new FormData();
  formData.append('id', props.driverId);
  formData.append('driver_id', driver.driver_id);
  // 格式化日期為 YYYY-MM-DD 格式
  if (driver.birthday instanceof Date) {
    const year = driver.birthday.getFullYear();
    const month = String(driver.birthday.getMonth() + 1).padStart(2, '0');
    const day = String(driver.birthday.getDate()).padStart(2, '0');
    formData.append('birthday', `${year}-${month}-${day}`);
  } else if (driver.birthday) {
    formData.append('birthday', driver.birthday);
  } else {
    formData.append('birthday', '');
  }
  formData.append('first_name', driver.first_name);
  formData.append('middle_name', driver.middle_name);
  formData.append('last_name', driver.last_name);
  formData.append('address', driver.address);
  formData.append('suburb', driver.suburb);
  formData.append('state', driver.state);
  formData.append('post_code', driver.post_code);
  formData.append('mobile', driver.mobile);
  formData.append('email', driver.email);
  formData.append('password', driver.pin);
  formData.append('enabled', driver.accessEnabled ? '1' : '0');
  formData.append('bad_driver', driver.badDriver ? '1' : '0');
  formData.append('license_number', driver.license_number);
  formData.append('plate_number', driver.plate_number);
  formData.append('abn', driver.abn);
  formData.append('confirmed_abn', driver.confirmed_abn);
  formData.append('subgroup_id', driver.subgroup);
  formData.append('method', driver.paymentMethod);
  formData.append('payment_enabled', driver.paymentEnabled ? '1' : '0');
  formData.append('withdraw_enabled', driver.withdraw_enabled ? '1' : '0');
  formData.append('pre_card_enabled', driver.pre_card_enabled ? '1' : '0');
  
  
  formData.append('referring_driver_id', driver.referringDriverId);
  formData.append('referring_driver_name', driver.referringDriverName);

  driver.accounts.forEach((acc, i) => {
    if (acc.id) {
      formData.append(`accounts[${i}][id]`, acc.id);
    }
    formData.append(`accounts[${i}][account_type]`, acc.type);
    formData.append(`accounts[${i}][nick_name]`, acc.nick_name);
    formData.append(`accounts[${i}][account_name]`, acc.account_name);
    formData.append(`accounts[${i}][bank]`, acc.bank);
    formData.append(`accounts[${i}][bsb]`, acc.bsb);
    formData.append(`accounts[${i}][account_number]`, acc.account_number);
    formData.append(`accounts[${i}][phone]`, acc.phone);
    formData.append(`accounts[${i}][email]`, acc.email);
    formData.append(`accounts[${i}][EAID]`, acc.card_id);
    formData.append(`accounts[${i}][auto_pay]`, acc.auto_pay ? '0' : '2');
  });

  driver.notes.forEach((note, index) => {
    if (note.id) {
      formData.append(`notes[${index}][id]`, note.id);
    }
    formData.append(`notes[${index}][note]`, note.text);
    formData.append(`notes[${index}][eye_catching]`, note.pinned ? '1' : '0');
  });

  if (deletedNoteIds.value.length > 0) {
    deletedNoteIds.value.forEach((id, index) => {
      formData.append(`delete_note_ids[${index}]`, id);
    });
  }

  if (driver.licenseFrontFile.length > 0) {
    formData.append('documents[0]', driver.licenseFrontFile[0].content);
    formData.append('document_name[0]', 'license_front');
  }

  if (driver.licenseBackFile.length > 0) {
    formData.append('documents[1]', driver.licenseBackFile[0].content);
    formData.append('document_name[1]', 'license_back');
  }

  driver.otherDocuments.forEach((doc, index) => {
    const docIndex = index + 2;
    formData.append(`documents[${docIndex}]`, doc.content);
    formData.append(`document_name[${docIndex}]`, 'other_documents');
  });

  if (deletedDocumentIds.value.length > 0) {
    deletedDocumentIds.value.forEach((id, index) => {
      formData.append(`delete_document_ids[${index}]`, id);
    });
  }

  try {
    await driverStore.editDriver(formData);
    closeModal();
    activeTab.value = 'general';
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'Error saving driver data',
      text: error.message,
    });
  }
};

onMounted(() => {
  activeTab.value = 'general';
});
</script>

<style scoped>
.btn-green {
  background: rgba(0, 201, 98, 1);
  color: black;
  border: none;
  border-radius: 30px;
  width: 150px;
  padding: 10px, 32px, 10px, 32px;
}

.btn-green:hover {
  background: rgba(0, 201, 98, 1);
  border-radius: 30px;
  padding: 10px, 32px, 10px, 32px;
}

.btn-cancel{
  background-color: #e6e9ec;
  border: 2px solid #8476f4;
  width: 150px;
}

.btn-cancel:hover{
  background-color: #e6e9ec;
  border: 2px solid #8476f4;
}

.btn-edit{
  color: #8476f5;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: #e6e9ec;
  border-radius: 10px;
  width: 90%;
  height: 90%;
  padding: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.background-white {
  background-color: white;
  padding: 10px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.modal-body {
  flex: 1;
}

.tab-content {
  min-height: 600px;
  padding: 20px;
  background-color: #fff;
  border-radius: 0px 10px 10px 10px;
}

.modal-footer {
  display: flex;
  justify-content: start;
  padding-top: 20px;
}

.btn-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}
.nav-tabs{
  border: none;
}

.nav-tabs .nav-link {
  border: none;
  margin-bottom: 0;
}

.nav-link.active {  
  color: white;
  background-color: #00c962;
  border: none;
}

.file-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.license-preview {
  width: 100%;
  height: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
  border-radius: 5%;
  background-color: white;
  padding: 20px;
}

.license-preview img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.license-placeholder {
  width: 100%;
  height: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 5%;
  padding: 20px;
  color: #999;
  font-size: 16px;
  background-color: white;
}

.card {
  margin-bottom: 12px;
  background-color: #e6e9ec;
}

.card-mh{
  min-height: 600px;
}

.card-body_padding{
  padding: 6px 1rem;
}

.card-other {
  height: auto;
}

.form-label{
  margin-top: 10px;
}

.notes {
  height: 620px;
}

.notes-list {
  max-height: 500px;
  overflow-y: auto;
  color: #5E707D;
  padding-right: 10px;
}

.notes-list::-webkit-scrollbar {
  width: 8px;
}

.notes-list::-webkit-scrollbar-thumb {
  background-color: #cccccc;
  border-radius: 4px;
}

.notes-list::-webkit-scrollbar-thumb:hover {
  background-color: #b3b3b3;
}

.notes-list::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.note-item {
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: white;
  word-wrap: break-word;
  white-space: normal;
  overflow-wrap: anywhere;
  max-width: 100%;
}

.note-body {
  display: grid;
  grid-template-columns: 1fr 28px;
  word-wrap: break-word;
  white-space: normal;
  overflow-wrap: anywhere;
  margin-bottom: 0;
}

.note-add_btn, .document-add_btn{
  width: 28px;
  height: 28px;
  text-align: center;
}

.note-btn{
  margin: 8px auto;
  padding: 0;
  display: block;
}

.add-note-section {
  margin-top: 15px;
}

.add-note-input {
  margin-top: 10px;
  padding: 16px 20px 10px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 0px 12px 0px rgba(5, 28, 44, 0.1);
}

.add-note-input textarea{
  border: 1px solid #00C962;
}

.pinned {
  color: #ff0000;
}

.document-list {
  margin-top: 10px;
  background-color: #fff;
  border-radius: 6px;
  overflow-y: auto;
}

.document-item {
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.document-button{
  font-size: 16px;
}

.btn-view{
  border-right: 1px solid gray;
  border-radius: 0px;
}

.document-name {
  font-size: 14px;
  color: #333;
}

.add-document {
  display: flex;
  justify-content: center;
}

.preview-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.preview-modal-content {
  background: white;
  border-radius: 10px;
  padding: 20px;
  width: auto;
  height: auto;
  max-width: 800px;
  position: relative;
}

.preview-modal-content .btn-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.preview-content {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}

@media (max-width:1400px) {
  .modal-body {
    overflow-y: auto;
  }
}

/* Address 與 Suburb / State / Post 並排；桌面版左側 textarea 與右欄等高 */
@media (min-width: 768px) {
  .address-location-row .address-textarea-stretch {
    min-height: 0;
    resize: vertical;
  }
}
</style>
